import {effect, Injectable, Signal} from '@angular/core';
import {UserDetails} from '../models/user-details';
import {ContextFromSignal} from '../models/context-from-signal';
import {BehaviorSubject} from 'rxjs';

const EmptyUserDetails: UserDetails = {
  given_name: '',
  fsp: '',
  contextKey: '',
  groupKey: '',
  businessAccountKey: '',
  subjectId: '',
  role: ''
};

@Injectable({
  providedIn: 'root',
})
export class SelectedAdviserService {
  private claimsDetails: UserDetails;

  private selectedRoleSignal: Signal<ContextFromSignal> | undefined;
  public selectedRole$ = new BehaviorSubject<UserDetails>(EmptyUserDetails);
  public selectedRole: UserDetails;

  constructor() {
    // Initialize signals if available
    if (window.data_access?.user_context) {
      this.selectedRoleSignal = window.data_access.user_context
        .selected_role as Signal<ContextFromSignal>;
    }

    // Setup effects in injection context
    effect(() => {
      if (!this.selectedRoleSignal) return;
      const Role: ContextFromSignal = this.selectedRoleSignal();
      this.setRoleObservable(Role);
    });
  }

  private setRoleObservable(role: ContextFromSignal): void {
    const updatedLoggedInRole = this.addClaims({
      fsp: role.fsp === 'MC' ? 'CONSULT' : role.fsp,
      contextKey: `${role.code1}-${role.code2}`,
      groupKey: role.groupKey,
      businessAccountKey: role.businessAccountKey,
      subjectId: role.subjectId,
      role: role.role
    } as UserDetails);

    if (updatedLoggedInRole.fsp !== '') {
      this.selectedRole = updatedLoggedInRole;
      this.selectedRole$.next(updatedLoggedInRole);
    }
  }

  private addClaims(userDetails: UserDetails): UserDetails {
    return Object.assign({}, this.claimsDetails, userDetails) as UserDetails;
  }

}
